import { createContext } from "react";

export interface UserPermission {
	id: string;
	userId: string;
	module: string;
	canCreate: boolean;
	canRead: boolean;
	canUpdate: boolean;
	canDelete: boolean;
	canExport: boolean;
	canShare: boolean;
}

export interface User {
	id: string;
	email: string;
	role: string;
	permissions: UserPermission[];
	firstName?: string;
	lastName?: string;
	locale?: string;
}

export interface AuthContextValue {
	user: User | null;
	isLoading: boolean;
	isAuthenticated: boolean;
	logout: () => void;
	refetch: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
